const addCommas = (num: string) => {
    let z = num.replace(/[^0-9.]/gi, "").replace(/^0+/,"").replace( /\d{1,3}(?=(\d{3})+(?!\d))/g , "$&,");
    if (z.indexOf(".") === 0) z = "0" + z;
    if (num.includes(".")) z = z.substring(0, z.indexOf(".") + 3);
    return z;
};

export default addCommas;